import React, { useEffect, useState } from "react";

const InvoiceList = () => {
  const [invoices, setInvoices] = useState([]);

  useEffect(() => {
    fetch("https://merch.tjdstore.in/api/Backend/invoice_view.php")
      .then((res) => res.json())
      .then((data) => {
        if (data.success) setInvoices(data.data);
      })
      .catch((err) => console.error("Error:", err));
  }, []);

  return (
    <div className="container mt-4">
      <h3 className="mb-4 text-center">📋 All Invoices</h3>

      {invoices.map((invoice) => (
        <div key={invoice.invoice_id} className="card mb-4 shadow-sm">
          <div className="card-body">
            <h5 className="card-title">Invoice #{invoice.invoice_id}</h5>
            <p><strong>Name:</strong> {invoice.name}</p>
            <p><strong>Mobile:</strong> {invoice.mobile}</p>
            <p><strong>Email:</strong> {invoice.email}</p>            
            <p><strong>Total:</strong> ₹{invoice.total}</p>
            <p><strong>Date:</strong> {new Date(invoice.created_at).toLocaleString()}</p>

            <h6 className="mt-3">Items:</h6>
            <table className="table table-bordered">
              <thead className="thead-light">
                <tr>
                  <th>Product Name</th>
                  <th>Product ID</th>
                  <th>Qty</th>
                  <th>Price</th>
                  <th>Subtotal</th>
        <th>CGST</th>
        <th>SGST</th>
                  <th>Total</th>
                </tr>
              </thead>
              <tbody>
                {invoice.items.map((item, idx) => (
                  <tr key={idx}>
                    <td>{item.product_name}</td>
                    <td>{item.product_id}</td>
                    <td>{item.qty}</td>
                    <td>₹{item.price}</td>
                    <td>₹{item.subtotal}</td>
                    <td>₹{item.cgst}</td>
                    <td>₹{item.sgst}</td>                    
                    <td>₹{item.total}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      ))}
    </div>
  );
};

export default InvoiceList;
